export const APP_LAYOUT_GEOMETRY = {
  maxWidth: 1600,
  paddings: {
    xxs: 4,
    sm: 6,
    md: 10
  }
};
